module.exports = __webpack_public_path__ + "static/media/consultorio-02.c527e480.JPG";